// MapLoadingOverlay.js - 按需加载地图资源时的轻量遮罩
export default class MapLoadingOverlay {
    /**
     * @param {Phaser.Scene} scene
     */
    constructor(scene) {
        this.scene = scene;
        this.container = null;
        this.text = null;
    }

    show(message = '正在加载地图...') {
        this.hide();

        const cam = this.scene.cameras.main;
        const bg = this.scene.add.rectangle(
            cam.centerX,
            cam.centerY,
            cam.width,
            cam.height,
            0x000000,
            0.65
        );
        bg.setScrollFactor(0);
        bg.setDepth(10000);

        const text = this.scene.add.text(cam.centerX, cam.centerY, message, {
            fontSize: '18px',
            fill: '#ffffff',
            fontFamily: 'monospace'
        });
        text.setOrigin(0.5);
        text.setScrollFactor(0);
        text.setDepth(10001);

        this.container = bg;
        this.text = text;
    }

    updateMessage(message) {
        if (this.text) {
            this.text.setText(message);
        }
    }

    hide() {
        if (this.text) {
            this.text.destroy();
            this.text = null;
        }
        if (this.container) {
            this.container.destroy();
            this.container = null;
        }
    }
}
